import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EModalSource, EModalStatus, TModalStatus } from 'shared/common/types/modal';

const initialState: TModalStatus = {
  status: EModalStatus.Hide,
  source: undefined,
};

/* istanbul ignore next */
const modalSlice = createSlice({
  initialState,
  name: 'modal',
  reducers: {
    setModalStatus: (state, action: PayloadAction<EModalStatus>) => {
      state.status = action.payload;
      if (action.payload === EModalStatus.Hide) {
        state.source = undefined;
      }
    },
    setModalSource: (state, action: PayloadAction<EModalSource>) => {
      state.source = action.payload;
    },
  },
});

export const {
  reducer: modalReducer,
  actions: { setModalStatus, setModalSource },
} = modalSlice;
